import React from 'react';
import { Field } from 'react-final-form';

import SelectInput from '../utils/SelectInput';

const SelectField = React.memo( ( {
  field, validate, value, name, ...rest
} ) => {
  if ( field ) {
    return (
      <Field name={field} validate={validate} type="select">
        {( { meta, input } ) => {
          const isInvalid = ( meta.touched && meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && !!meta.submitError );

          return (
            <SelectInput
              {...input}
              {...rest}
              isInvalid={isInvalid}
              inputName={input.name}
              value={input.value}
              inputOnChange={input.onChange}
              meta={meta}
            />
          );
        }}
      </Field>
    );
  }

  return (
    <SelectInput
      {...rest}
      inputName={name}
      value={value}
    />
  );
} );

export default SelectField;
